import React, { useState } from 'react'
import { ChevronDown, Clock, DollarSign } from 'lucide-react';
import BookingForm from './BookingForm';
import { Link, useParams } from 'react-router-dom';

function ServiceCard({ services, user }) {
    const userType = user;
    const city = useParams();
    const [openService, setOpenService] = useState(null);
    const [showBooking, setShowBooking] = useState(false);
    const [selectedService, setSelectedService] = useState(null);

    if (showBooking) {
        return (
            <BookingForm
                services={services}
                preselectedService={selectedService}
                onBack={() => setShowBooking(false)}
            />
        );
    }

    return (
        <div className="bg-white rounded shadow p-2 w-100 transition">
            <h3 className="display-5 fw-bold mb-3 text-warning text-center">Our Services</h3>

            <div className="ps-2 pe-2">
                {services.map((service, index) => (
                    <div key={index} className='border rounded border-warning border-opacity-25 bg-white mb-2 p-2 w-100'>
                        <div className='d-flex flex-column' onClick={() => setOpenService(openService === index ? null : index)}>
                            <div className='d-flex flex-inline justify-content-between align-items-center w-full'>
                                <div className=''>
                                    <span className="text-start fw-bolder text-dark">{service.name}</span>
                                    {service.badge && (
                                        <span className={`ms-1 text-xs px-2 py-0.5 rounded bg-warning bg-opacity-50`}>
                                            {service.badge}
                                        </span>
                                    )}
                                    <div className="text-start text-black-50">
                                        {service.mini}
                                    </div>
                                </div>
                                <ChevronDown
                                    className={`transition-transform ${openService === index ? 'rotate-180' : ''}`}
                                    size={25}
                                />
                            </div>

                            {openService === index && (
                                <div className='d-flex flex-column bg-warning bg-opacity-25 mt-2 p-2 rounded'>
                                    <p className="text-dark text-start mt-1">
                                        {service.description}
                                    </p>
                                    {service.options && service.options.length > 0 && (
                                        <div className="text-start mt-2">
                                            <p className="fw-bolder text-sm text-gray-900 mb-2 text-decoration-underline">Options</p>
                                            {service.options.map((option, idx) => (<>
                                                <div key={idx} className="d-flex justify-content-between text-dark">
                                                    {option.name}
                                                    <div className='d-flex align-items-center'>
                                                        <Clock className='text-primary me-1' size={14} />
                                                        {option.duration} &nbsp;
                                                        {option.price !== "Free" && option.price !== null ? <>| &nbsp;
                                                            <DollarSign className='text-success' size={14} />
                                                            {option.price}</> : ""}
                                                    </div>
                                                </div>
                                                {(option.name === "Traditional" || option.name === "Traditional Deluxe" || option.name === "Level 3 Traditional") ? (
                                                    <div className='text-start text-secondary fst-italic' style={{ fontSize: "0.75rem" }}>
                                                        (Giver &amp; Receiver Nude)
                                                    </div>
                                                ) : ""}
                                            </>
                                            ))}
                                        </div>
                                    )}

                                    <Link
                                        //onClick={() => setSelectedService(service)}
                                        to={`/${city.cityName}/booking`}
                                        state={{ service: service, userType: userType }}
                                        className="w-100 bg-warning text-dark py-2 rounded fw-semibold border-0 mt-3"
                                        style={{
                                            transition: "all 0.3s ease",
                                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = "#ffc107";
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = "";
                                            e.target.style.transform = "";
                                            e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                                        }}
                                    >
                                        {service.name === "Subscription" ? "Build Your Subscription" : `Book Your ${service.name}`}
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>

                ))}
            </div>
            <Link
                to={`/${city.cityName}/booking`}
                state={{ service: null, userType: userType }}>
                <button
                    className="w-100 text-white py-2 rounded fw-semibold border-0 mt-3"
                    style={{
                        backgroundColor: "rgb(0, 45, 100)",
                        transition: "all 0.3s ease",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                    }}>
                    Book Your Session
                </button>
            </Link>
        </div>
    );
}

export default ServiceCard
